import * as yup from 'yup';

export const createValidationSchema = (): yup.AnyObjectSchema => {
  return yup.object({
    addedArticleId: yup.string().required('common.not_empty'),
    multiplier: yup.number().required('common.not_empty').max(999.99, 'common.value_less_999_99'),
  });
};
